var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttackInspector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1420.671 139.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M87.127,121.977,79.363,96.489H40.325l-7.764,25.488H8.1L45.892,14.458H73.65l37.94,107.519ZM73.943,77.446Q63.178,42.8,61.822,38.262t-1.941-7.178q-2.418,9.377-13.843,46.362Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.375,121.977H140.67V33.794H111.593V14.9h80.859v18.9H163.375Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,121.977H224.535V33.794H195.458V14.9h80.859v18.9H247.24Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.349,121.977l-7.764-25.488H308.547l-7.764,25.488H276.32L314.113,14.458h27.759l37.939,107.519ZM342.165,77.446Q331.4,42.8,330.043,38.262T328.1,31.084q-2.416,9.377-13.842,46.362Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.771,32.256q-12.818,0-19.848,9.632T408.892,68.73q0,35.816,26.879,35.816,11.279,0,27.32-5.64v19.043a75.873,75.873,0,0,1-29.444,5.493q-23.364,0-35.742-14.172T385.527,68.584q0-16.7,6.079-29.261a43.932,43.932,0,0,1,17.469-19.262q11.387-6.7,26.7-6.7A72.075,72.075,0,0,1,467.119,20.9L459.8,39.36a121.721,121.721,0,0,0-12.085-4.98A36.062,36.062,0,0,0,435.771,32.256Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569,121.977H543.221L515.169,76.86l-9.595,6.885v38.232h-22.7V14.9h22.7v49l8.936-12.6,29-36.4h25.195L531.355,62.285Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.443,121.977V14.9h22.705v107.08Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.1,121.977H728.239L681.657,40.971H681q1.39,21.462,1.392,30.616v50.39H662.1V14.9h28.638l46.509,80.2h.513q-1.1-20.874-1.1-29.516V14.9H757.1Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.258,92.241q0,14.5-10.437,22.852t-29.041,8.349q-17.139,0-30.322-6.445V95.9a124.935,124.935,0,0,0,18.348,6.812,54.289,54.289,0,0,0,13.732,1.977q7.47,0,11.463-2.856t3.991-8.5a9.38,9.38,0,0,0-1.758-5.6,19.661,19.661,0,0,0-5.163-4.724,133.1,133.1,0,0,0-13.88-7.251q-9.816-4.615-14.721-8.863a33.225,33.225,0,0,1-7.837-9.887,28.221,28.221,0,0,1-2.93-13.184q0-14.21,9.632-22.339t26.623-8.13a62.837,62.837,0,0,1,15.93,1.978A109.691,109.691,0,0,1,843.745,20.9l-7.324,17.652a107.254,107.254,0,0,0-14.172-4.908,45.709,45.709,0,0,0-11.023-1.391q-6.446,0-9.888,3A9.9,9.9,0,0,0,797.9,43.1a9.7,9.7,0,0,0,1.392,5.237,15.263,15.263,0,0,0,4.431,4.32q3.039,2.09,14.392,7.508,15.014,7.179,20.581,14.393T844.258,92.241Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.642,48.3q0,17.286-10.8,26.44t-30.726,9.155h-9.741v38.086h-22.7V14.9h34.2q19.482,0,29.626,8.387T934.642,48.3Zm-51.27,16.992h7.471q10.473,0,15.674-4.139t5.2-12.048q0-7.981-4.359-11.792T893.7,33.5H883.372Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.526,121.977h-61.67V14.9h61.67V33.5H974.561V57.012h36.255v18.6H974.561v27.612h38.965Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.348,32.256q-12.817,0-19.849,9.632t-7.031,26.842q0,35.816,26.88,35.816,11.277,0,27.319-5.64v19.043a75.871,75.871,0,0,1-29.443,5.493q-23.366,0-35.743-14.172T1028.1,68.584q0-16.7,6.08-29.261a43.93,43.93,0,0,1,17.468-19.262q11.388-6.7,26.7-6.7A72.074,72.074,0,0,1,1109.7,20.9l-7.324,18.457a121.523,121.523,0,0,0-12.085-4.98A36.056,36.056,0,0,0,1078.348,32.256Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.755,121.977H1144.05V33.794h-29.077V14.9h80.859v18.9h-29.077Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.5,68.291q0,26.586-13.184,40.869t-37.793,14.282q-24.609,0-37.793-14.282t-13.183-41.016q0-26.733,13.219-40.833t37.9-14.1q24.681,0,37.757,14.209T1306.5,68.291Zm-78.15,0q0,17.946,6.812,27.026t20.361,9.082q27.173,0,27.173-36.108,0-36.181-27.026-36.182-13.551,0-20.435,9.118T1228.354,68.291Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.4,80.888v41.089H1325.7V14.9h31.2q21.825,0,32.3,7.948t10.474,24.132a28.413,28.413,0,0,1-5.2,16.809,34.413,34.413,0,0,1-14.722,11.536q24.17,36.108,31.494,46.655h-25.195l-25.562-41.089Zm0-18.457h7.325q10.765,0,15.893-3.588t5.127-11.28q0-7.617-5.237-10.84T1355.286,33.5H1348.4Z",
    style: {
      fill: "#05b758"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackInspector);
export default __webpack_public_path__ + "static/media/Attack-Inspector.67446b7f6276c95e379a26833307bf34.svg";
export { ForwardRef as ReactComponent };